import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-170" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-gray-200 border-l-4 border-l-gold bg-white p-4 pr-10 text-navy shadow-lg" aria-live="polite" data-id="element-171" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-gray-400 transition-colors duration-150 ease-out hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600" aria-label="Dismiss notice" data-id="element-172" data-mp="1sfmql43vef5q">
            <XIcon className="h-4 w-4" data-id="element-173" data-mp="1ngjljjnw48xr" />
          </button>
          <div className="flex gap-3" data-id="element-174" data-mp="1nf061va261x1">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-aqua" aria-hidden="true" data-id="element-175" data-mp="19pogyjkfcdzz" />
            <div data-id="element-176" data-mp="1efv7wq2esale">
              <p className="text-xs font-semibold text-aqua" data-id="element-177" data-mp="1egembwsuoguo">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-gray-600" data-id="element-178" data-mp="zrig85actdwp">
                Once your purchase is complete you receive the
                <br data-id="element-179" data-mp="14r3iaoktm2dn" />
                <span className="font-semibold text-navy" data-id="element-180" data-mp="14qlcp1c9qbt2">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-gray-500" data-id="element-181" data-mp="qrc70vlov03c">Instant digital access by email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}